import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import api from "../../AxiosHelper";
import localStorageCall from "../../Methods/localstorage.hook";
import { MIDDLE_CREDENTIAL, storeAssigned } from "../../Methods/normalMethods";
import { getAllCustomerData } from "./LoginSlice";
import { _storeCustomerTypes } from "../../Methods/commonPayload";

const CustomerSlice = createSlice({
    name: "customerSlice",
    initialState: {
        webAliseFilterData: [],
        savedCards: [],
        isLoading: false,
        userAccount: "",
        errorMsg: "",
        resetEmail: "",
        resetPass: "",
        emailerror: "",
        successmsg: null,
        countryData: [],
        gNumberErrorMsg: ""
    },
    reducers: {
        setWebAliesFilter: (state, action) => {
            state['webAliseFilterData'] = action?.payload;
        },
        setLoading: (state, action) => {
            state['isLoading'] = action?.payload;
        },
        setError: (state, action) => {
            state['errorMsg'] = action.payload;
        },
        setGNumberError: (state, action) => {
            state['gNumberErrorMsg'] = action.payload;
        },
        setSavedCards: (state, action) => {
            state['savedCards'] = action.payload?.data;
        },
        setResetEmail: (state, action) => {
            state['resetEmail'] = action.payload?.data;
        },
        setResetPassword: (state, action) => {
            state['resetPass'] = action.payload?.data;
        },
        setSuccessMsg: (state, action) => {
            state['successmsg'] = action.payload;
        },
        setEmailError: (state, action) => {
            state['emailerror'] = action.payload;
        },
        setCountryData: (state, action) => {
            state['countryData'] = action.payload?.data
        }
    }
});

export const {
    setWebAliesFilter, setLoading, setError, setGNumberError, setSavedCards, setUserAccount, setResetEmail, setResetPassword, setEmailError, setCountryData,
    setSuccessMsg
} = CustomerSlice?.actions;

const ErrorMsg = (errorResult) => dispatch => {
    if (errorResult?.length > 0) {
        _.map(errorResult, ({ errorMessage }) => {
            if (errorMessage) {
                dispatch(setError(errorMessage));
                setTimeout(() => dispatch(setError("")), 4000);
                return;
            }
        });
    }
}

export const getCustomerRefferal = (callback, webAlies = null, section = "normal", currentpage = 0) => dispatch => {
    console.log(webAlies, 'webAlies******************88');
    let URL = "";


    if (section === "phoneNumber") {
        URL = `/Crm/Customers/?PhoneNumbers/CellPhone=eq:${webAlies.replace(/[\s~`!@#$%^&*(){}\[\];:"'<,.>?\/\\|_+=-]/g, '')}`;
    } else if (section === "urlRef") {
        URL = `/Crm/Customers/?WebAlias=eq:${webAlies}`;
    } else {
        const webAlias = webAlies?.webAliase ? `WebAlias=eq:${webAlies?.webAliase.trim()}&` : "";  // Only include WebAlias if it exists
        const firstname = webAlies?.firstName ? `firstName=eq:${webAlies?.firstName.trim()}&` : "";
        const lastname = webAlies?.lastName ? `lastName=cn:${webAlies?.lastName.trim()}&` : "";
        const city = webAlies?.city ? `mailingAddress/city=eq:${webAlies?.city.trim()}&` : "";
        const zipcode = webAlies?.zipcode ? `mailingAddress/postalCode=eq:${webAlies?.zipcode.trim()}&` : "";
        const state = webAlies?.state ? `mailingAddress/regionProvState=eq:${webAlies?.state}&` : "";
        const emailAddress = webAlies?.emailAddresse ? `emailAddress=eq:${webAlies?.emailAddresse.trim()}&` : "";
        const customerId = webAlies?.customerId ? `customerId=eq:${webAlies?.customerId.trim()}&` : "";
        // customerId
        // Build the URL dynamically based on available parameters
        const url = `/Crm/Customers/?customerStatusTypeDescr=eq:Commissionable&${firstname}${lastname}${city}${zipcode}${state}${webAlias}${emailAddress}${customerId}OrderByColumn=widthMetric&OrderByMethod=desc`;
        URL = encodeURI(url);
    }

    // console.log("URL", URL);
    // dispatch(setLoading(true));
    api().post().data({
        method: "GET",
        endpoint: URL
    }).success((res) => {
        dispatch(setLoading(false));
        if (res?.data) {
            if (callback) {
                callback(res?.data, res?.totalRecords);
            }
            dispatch(setWebAliesFilter(res));
            return res?.data;
        }
    }).error((err) => {
        dispatch(ErrorMsg(err?.errorResults));
        dispatch(setLoading(false));
    }).send();
}
export const getCustomerSavedCard = (id = null, callback,) => dispatch => {
    const URL = `/Crm/Customers/${id}/AccountBilling`;
    dispatch(setLoading(true));
    api().post().data({
        method: "GET",
        endpoint: URL
    }).success((res) => {
        dispatch(setLoading(false));
        if (res?.data) {
            dispatch(setSavedCards(res));
            if (callback) {
                callback(res?.data);
            }
        }
    }).error((err) => {
        dispatch(ErrorMsg(err?.errorResults));
        dispatch(setLoading(false));
    }).send();
}

//
export const getUserCredentialApi = (ssokey, navigate, REDIRECT_PAGE) => dispatch => {
    dispatch(setLoading(true));
    api().post().data({
        method: "GET",
        endpoint: `/Authorize/DecryptSSOKey?ssokey=${ssokey}`
    }).success((res) => {
        dispatch(setLoading(false));
        // dispatch(setUserAccount(res));
        localStorageCall().setItem('Token', res?.data);
        dispatch(getAllCustomerData((data) => {
            _storeCustomerTypes(dispatch, data?.customerId);
            localStorageCall().setItem('store', _.lowerCase(data?.countryCode) || 'us');
            const refferalData = JSON.stringify({ "id": data?.enrollerId, "name": data?.enrollerName, "webalies": data?.enrollerName });
            localStorageCall().setItem('refferal_link', refferalData);
            navigate.push(REDIRECT_PAGE ? `/${storeAssigned()}${REDIRECT_PAGE}` : `/${storeAssigned()}`)
        }, res?.data));
    }).error((err) => {
        navigate.push(`/${storeAssigned()}`)
        dispatch(ErrorMsg(err?.errorResults));
        dispatch(setLoading(false));
    }).send();
}

//*************reset email**************************************************

export const ResetEmailApi = ({ email }, callback = null) => dispatch => {
    const header = { CustomerUsername: email };
    dispatch(setLoading(true));
    api().setHeaders(MIDDLE_CREDENTIAL).post().data({
        endpoint: '/Crm/Customers/PasswordRecovery',
        method: "resetPassword",
        ...header
    }).success((res) => {
        dispatch(setLoading(false));
        dispatch(setResetEmail(res));
        if (callback) {
            callback(res);
        }
        // localStorageCall().setItem('TokenEmail', action.payload?.data);
        window.location.assign(`/${storeAssigned()}/forgotPassword?sessionId=${res?.data}`)
    }).error((err) => {
        dispatch(setEmailError(err?.errorMessage));
        setTimeout(() => dispatch(setEmailError('')), 2000);
        if (callback) {
            callback(err);
        }
        dispatch(setLoading(false));
    }).send();
}
//**********************************reset password******************************************/

export const NewPasswordApi = ({ password, sessionId, passwordKey }, callback = null) => dispatch => {

    dispatch(setLoading(true));
    api().setHeaders(MIDDLE_CREDENTIAL).post().data({
        method: "updatePassword",
        endpoint: `/Crm/Customers/SubmitPasswordRecovery?sessionId=${sessionId}&key=${passwordKey}`,
        CustomerPassword: password
    }).success((res) => {
        dispatch(setLoading(false));
        dispatch(setResetPassword(res));
        dispatch(setSuccessMsg('You have changed your password successfully'));
        setTimeout(() => dispatch(setSuccessMsg('')), 4000);
        if (callback) {
            callback(res)
        }
        // localStorageCall().removeItem("PasswordKey")
        // localStorageCall().removeItem("TokenEmail")
        setTimeout(() => window.location.assign(`/`), 3000);
    }).error((err) => {
        dispatch(setEmailError(err?.errorMessage));
        setTimeout(() => dispatch(setEmailError('')), 3000);
        dispatch(setLoading(false));
    }).send();
}

// contact us api


export const ContactUsApi = (values, callback) => dispatch => {
    // dispatch(setLoading(true));
    api().root(import.meta.env.VITE_COMPANY_TOKEN).setHeaders(MIDDLE_CREDENTIAL).post('/contactusprovizion.php').data(values)
        .success((res) => {
            if (res?.status === 1) {
                // dispatch(setLoading(false));
                callback(res?.status)
            }
        }).error(() => { }).send()
}

export const _unilevelTreeUpdate = (customerId, callback = null, treeType = 2, setCheckoutProcessing) => dispatch => {
    try {
        const REFFERAL_VALUES = localStorageCall().getItem('refferal_link');  /*** get Refferal value from cookiee ***/
        const TreeMoveData = localStorageCall().getItem('TreeMoveData');
        api().post().data({
            method: "POST",
            endpoint: `/Crm/Customers/${customerId}/TreeMove`,
            data: JSON.stringify({
                "treeType": TreeMoveData ? TreeMoveData?.treeType : 2,
                //"parentId": TreeMoveData ? TreeMoveData?.pid : REFFERAL_VALUES?.id || 2,
                //"placementId": TreeMoveData ? TreeMoveData?.placementId : 0
                "parentId": TreeMoveData ? TreeMoveData?.pid : REFFERAL_VALUES?.id || 2,
                "placementId": 0,
                "placementType": TreeMoveData ? TreeMoveData?.placementType : 0,
                "subPlacementType": TreeMoveData ? TreeMoveData?.placementId : 0
            })
        }).success((res) => {
            dispatch(setLoading(false));
            if (callback) {
                callback();
            }
        }).error((err) => {
            setCheckoutProcessing(false);
            dispatch(setEmailError(err?.errorMessage));
            setTimeout(() => dispatch(setEmailError('')), 8000);
            dispatch(setLoading(false));
        }).send();
    } catch (e) {
        // console.log(e)
    }
}

export const _updateTaxation = (customerId, callback = null, data, setCheckoutProcessing) => dispatch => {
    try {
        api().post().data({
            method: "PUT",
            endpoint: `/Crm/Customers/${customerId}/UpdateTaxation`,
            data: JSON.stringify({
                "taxIdType": +data?.taxType || 0,
                "taxId": data?.taxId || ""
            })
        }).success((res) => {
            dispatch(setLoading(false));
            if (callback) {
                callback();
            }
        }).error((err) => {
            setCheckoutProcessing(false);
            dispatch(setEmailError(err?.errorMessage));
            setTimeout(() => dispatch(setEmailError('')), 8000);
            dispatch(setLoading(false));
        }).send();
    } catch (e) {
        // console.log(e)
    }
}

//********************************** country fetching api call ******************************************/
export const _getCountryCodeApi = (callback) => dispatch => {
    dispatch(setLoading(true));
    api().setHeaders(MIDDLE_CREDENTIAL).post().data({ method: "GET", endpoint: `/Settings/Countries` }).success((res) => {
        dispatch(setLoading(false));
        dispatch(setCountryData(res));
        if (res?.data?.length > 0 && callback) {
            callback(res?.data)
        }
    }).error((err) => dispatch(setLoading(false))).send();
}

//********************************** priceType according customerType fetching api call ******************************************/
export const _getCusotmerPriceType = (callback, customerTypeDesc) => dispatch => {
    dispatch(setLoading(true));
    api().setHeaders(MIDDLE_CREDENTIAL).post().data({ method: "GET", endpoint: `/Settings/PriceTypes` }).success((res) => {
        dispatch(setLoading(false));
        if (res?.data?.length > 0 && callback) {
            const PRICE_TYPES = _.find(res?.data, (row) => _.includes(_.split(_.lowerCase(customerTypeDesc), ' ')?.[0], _.lowerCase(row?.description)));
            callback(PRICE_TYPES)
        }
    }).error((err) => dispatch(setLoading(false))).send();
}

export const getGNumberIdentifier = (code = null, callback) => dispatch => {
    const URL = `/Crm/Customers/IssuedIdentifier/${code}`;
    dispatch(setGNumberError(""))
    api().post().data({
        method: "GET",
        endpoint: URL
    }).success((res) => {
        dispatch(setGNumberError(""));
        if (callback) {
            callback();
        }
    }).error((err) => {
        dispatch(setGNumberError(err?.errorResults ? "This Gaiyoshomen Number is already registered to a Viágo Account. Please update to move forward." : ""));
        if (callback) {
            callback();
        }
    }).send();
}

export const _addGNumberIdentifier = (customerId, IdentifierCode, callback = null, setCheckoutProcessing) => dispatch => {
    try {
        dispatch(setEmailError(''));
        api().post().data({
            method: "PUT",
            endpoint: `/Crm/Customers/${customerId}/IssuedIdentifier/${IdentifierCode}`,
        }).success((res) => {
            dispatch(setLoading(false));
            if (callback) {
                callback();
            }
        }).error((err) => {
            setCheckoutProcessing(false);
            dispatch(setEmailError(err?.errorMessage));
            setTimeout(() => dispatch(setEmailError('')), 80000);
            dispatch(setLoading(false));
        }).send();
    } catch (e) {
        // console.log(e)
    }
}


export default CustomerSlice?.reducer;

